<template>
  <h1
    class="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-8 text-center min-h-[2.5rem] streaming-question"
    :dir="textDirection"
    :style="{ textAlign: 'center', unicodeBidi: 'isolate' }"
  >
    <span class="streaming-text">{{ displayedText }}</span><span v-if="isStreaming === true" class="streaming-cursor inline-block w-[2px] h-7 bg-blue-500 ml-0.5 align-middle animate-pulse"></span>
  </h1>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  startDelay: {
    type: Number,
    default: 600
  },
  charDelay: {
    type: Number,
    default: 55
  }
});

const emit = defineEmits(['complete']);

const displayedText = ref('');
const isStreaming = ref(false);

const textDirection = computed(() => {
  return resolveTextDirection(props.text);
});

function resolveTextDirection(text) {
  if (typeof text !== 'string') {
    return 'ltr';
  }
  let index = 0;
  while (index < text.length) {
    const code = text.charCodeAt(index);
    if ((code >= 0x0590 && code <= 0x05FF) || (code >= 0x0600 && code <= 0x06FF) || (code >= 0xFB1D && code <= 0xFDFF) || (code >= 0xFE70 && code <= 0xFEFF)) {
      return 'rtl';
    }
    index = index + 1;
  }
  return 'ltr';
}

function resetAndStream() {
  displayedText.value = '';
  isStreaming.value = false;
  const source = typeof props.text === 'string' ? props.text : '';
  if (source.length === 0) {
    emit('complete');
    return;
  }
  window.setTimeout(() => {
    isStreaming.value = true;
    let index = 0;
    const timer = window.setInterval(() => {
      if (index < source.length) {
        displayedText.value = displayedText.value + source[index];
        index = index + 1;
      } else {
        window.clearInterval(timer);
        isStreaming.value = false;
        emit('complete');
      }
    }, props.charDelay);
  }, props.startDelay);
}

watch(() => props.text, () => {
  resetAndStream();
});

onMounted(() => {
  resetAndStream();
});
</script>

<style scoped>
.streaming-question {
  animation: questionFadeIn 360ms ease;
}

.streaming-text {
  white-space: pre-wrap;
}

@keyframes questionFadeIn {
  0% {
    opacity: 0.35;
  }
  100% {
    opacity: 1;
  }
}
</style>
